import {
    Clock3,
    CheckCircle2,
    XCircle,
    Ban,
} from "lucide-react";

function ProviderStatusBadge({ status }) {

    const currentStatus = (status || "Pending").toLowerCase();

    switch (currentStatus) {

        case "approved":

            return (
                <span className="provider-status-badge approved">
                    <CheckCircle2 size={14} />
                    Approved
                </span>
            );

        case "rejected":

            return (
                <span className="provider-status-badge rejected">
                    <XCircle size={14} />
                    Rejected
                </span>
            );

        case "suspended":

            return (
                <span className="provider-status-badge suspended">
                    <Ban size={14} />
                    Suspended
                </span>
            );

        default:

            return (
                <span className="provider-status-badge pending">
                    <Clock3 size={14} />
                    Pending
                </span>
            );

    }

}

export default ProviderStatusBadge;